import { inject, Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class RouteTrackerService {
  private previousUrl: string;
  public router = inject(Router);

  constructor() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.previousUrl = this.router.url;
      }
    });
  }

  getPreviousUrl(): string | null {
    return this.previousUrl;
  }
}
